@if (refinementDescriptor && refinementRenderOptions?.items && refinementRenderOptions?.canRefine) {
    <div
        class="flex flex-col"
    >
        <div class="flex flex-row justify-between">
            <label for="{{refinementDescriptor.name}}-toggle-expanded" class="body-default-bold">{{refinementDescriptor.title}}</label>
            <button id="{{refinementDescriptor.name}}-toggle-expanded" *ngIf="canExpandRefinement" (click)="toggleExpanded()">
                <span class="material-symbols-rounded">{{ expanded ? expandedIconName : collapsedIconName }}</span>
            </button>
        </div>

        <div *ngIf="!canExpandRefinement || expanded" class="flex flex-col">
            <div *ngIf="refinementDescriptor.isSearchable">
                <app-input
                    [formControl]="searchRefinementControl"
                    id="{{refinementDescriptor.name}}-search-input"
                    placeholder="Search {{refinementDescriptor.title}}"
                />
            </div>
            <ul>
                <li 
                    *ngFor="let item of refinementRenderOptions?.items; let i=index"
                    class="flex flex-row justify-between py-1"
                >
                    <div class="flex gap-2">
                        <input 
                            type="checkbox" 
                            id="{{refinementDescriptor.name}}-{{i}}" 
                            (change)="onCheckBoxChanged(item)"
                            [checked]="item.isRefined"
                        />
                        <label 
                            for="{{refinementDescriptor.name}}-{{i}}"
                            class="body-default-regular"
                            >
                            {{item.label}}
                        </label>
                    </div>
                    <app-badge>{{item.count}}</app-badge>
                </li>
            </ul>
            <button *ngIf="refinementRenderOptions?.canToggleShowMore" 
                class="btn btn-link-blue" 
                id="{{refinementDescriptor.name}}-show-more-less" 
                (click)="toggleShowMore()"
            >
                {{ refinementRenderOptions?.isShowingMore ? 'Show Less' : 'Show More' }}
            </button>
        </div>
    </div>
}
